import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Translate, {t} from "../../../../components/Translate";
import {updateTicketDescriptionAndAssignedUser} from "../../../../services/company/api";
import SilverButton from "../../../../components-new/buttons/SilverButton";
import BlueButton from "../../../../components-new/buttons/BlueButton";
import DropdownSelect from "../../../../components-new/form/DropdownSelect";
import config from "../../../../config";
import Input from "../../../../components-new/form/Input";
import Colors from "../../../../utils/Colors";
import Modal from "../../../../components-new/ui/Modal";


const styles = {
    overlay: {
        backgroundColor: config.modalBackgroundColor,
        zIndex: '2000',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    content: {
        backgroundColor: 'var(--ds-bg-primary)',
        color: Colors.blueDark,
        padding: '40px',
        borderRadius: '20px',
        maxWidth: '500px',
        width: '100%',
        boxSizing: 'border-box',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
        textAlign: 'center',
        transition: 'opacity 0.3s ease-out, transform 0.3s ease-out',
        animation: 'fadeIn 0.3s ease-out',
    },
    title: {
        color: '#09183A',
        fontSize: '22px',
        marginBottom: '30px',
        textAlign: 'center',
    },
    infoRow: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '20px',
        alignItems: 'center',
    },
    _infoRow: {
        marginBottom: '20px',
        padding: '20px',
        borderRadius: '10px',
        backgroundColor: 'rgb(241, 241, 241)',
        textAlign: 'left',
    },
    label: {
        fontWeight: 'bold',
        color: '#09183A',
        marginBottom: '5px',
    },
    value: {
        color: '#5a5a5a',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap',
    },
    select: {
        padding: '10px',
        borderRadius: '10px',
        border: '1px solid #103c5b',
        backgroundColor: 'var(--ds-bg-primary)',
        color: '#103c5b',
        width: '100%',
        fontSize: '14px',
        marginLeft: '20px'
    },
    buttonsWrapper: {
        textAlign: 'center',
        marginTop: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
};


const TicketPopup = ({
                         isOpen,
                         onClose,
                         content,
                         user,
                         users,
                         updatePopupContent,
                         addNotification
                     }) => {
    const [assignedUser, setAssignedUser] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (content) {
            setAssignedUser(content.assignedUser ? content.assignedUser.platformId : '');
            setDescription(content.description || '');
        }
    }, [content]);

    const handleUserChange = (e) => {
        setAssignedUser(e.target.value);
    };

    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
    };

    const handleSaveTicket = () => {
        const ticketId = content.id;
        updateTicketDescriptionAndAssignedUser(ticketId, description, assignedUser).then(data => {
            updatePopupContent(data);
            addNotification('saved', config.notificationLevels.info)
        });
    }

    return (
        <Modal
            isOpen={isOpen}
            onCancel={onClose}
            header={<h2 style={{...styles.title, marginBottom: 0}}>{content && content.subject}</h2>}
            style={{
                overlay: {backgroundColor: config.modalBackgroundColor, zIndex: 2000},
                content: {
                    top: '50%', left: '50%', right: 'auto', bottom: 'auto',
                    transform: 'translate(-50%, -50%)', width: 'min(500px, calc(100vw - 32px))',
                    border: 'none', maxHeight: '90vh',
                },
            }}
            footer={
                <React.Fragment>
                    <SilverButton type="button" onClick={onClose} width="130px" height="36px">
                        <Translate text="close"/>
                    </SilverButton>
                    <BlueButton type="button" onClick={() => {
                        onClose();
                        handleSaveTicket();
                    }} width="150px" height="36px">
                        <Translate text="save"/>
                    </BlueButton>
                </React.Fragment>
            }
        >
            {content && <React.Fragment>
                <div style={styles.infoRow}>
                    <span style={styles.label}><Translate text="category"/>:</span>
                    <span style={styles.value}>{content.categoryName}</span>
                </div>
                <div style={styles.infoRow}>
                    <span style={styles.label}><Translate text="priority"/>:</span>
                    <span style={styles.value}>{t({text: content.priority, user})}</span>
                </div>
                <div style={styles.infoRow}>
                    <span style={styles.label}><Translate text="user"/>:</span>
                    {content.conversation &&
                        <span
                            style={styles.value}>{content.conversation.user.firstName + " " + content.conversation.user.lastName}</span>
                    }
                </div>
                <div style={styles.infoRow}>
                    <span style={styles.label}><Translate text="assignee"/>:</span>
                    <DropdownSelect
                        options={users.map(user => ({
                            value: user.id,
                            label: `${user.firstName} ${user.lastName}`,
                        }))}
                        selectedValue={assignedUser}
                        onChange={(newValue) => handleUserChange({target: {value: newValue.value}})}
                        renderLabel={(value) => {
                            const selectedUser = users.find(user => user.id === value);
                            return selectedUser ? `${selectedUser.firstName} ${selectedUser.lastName}` : '';
                        }}
                        style={styles.select}
                        placeholder={t({text: "selectUser", user})}
                    />
                </div>

                <br/>
                <br/>
                <div style={styles._infoRow}>
                    <span style={styles.label}><Translate text="description"/>:</span>
                    <Input
                        isTextarea={true}
                        style={{resize: 'none'}}
                        maxLength={5000}
                        value={description}
                        onChange={handleDescriptionChange}
                    />
                </div>
            </React.Fragment>}
        </Modal>
    );
};

TicketPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    content: PropTypes.object,
    user: PropTypes.object.isRequired,
    users: PropTypes.array.isRequired
};


export default TicketPopup;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/my-history/TicketPopup.jsx